import axios from "axios";
export const API_URL = "/api/v1";
export const GET_SUMMARY_WASTE_COLLECT_DATA_LIST_URL  = API_URL+"/summary_waste_collect/summary_waste_collect_data_for_collection_company/";
export const GET_SUMMARY_WASTE_COLLECT_DATA_LIST_THIS_MONTH_URL  = API_URL+"/summary_waste_collect/summary_waste_collect_data_for_collection_company_this_month/";
export const GET_SUMMARY_WASTE_COLLECT_DATA_LIST_ALL_URL  = API_URL+"/summary_waste_collect/summary_waste_collect_data_for_collection_company_all/";


// export function saveWasteCollect(params) {
//   return axios.post(SAVE_WASTE_COLLECT_URL, params);
// }

export function getSummaryWasteCollectDataList(params) {
  return axios.get(GET_SUMMARY_WASTE_COLLECT_DATA_LIST_URL  + '?page='+ params.page + '&summary_date=' + params.summary_date + '&company_name=' + params.company_name + '&company_number='+params.company_number + '&type=' + params.type);
}

export function getSummaryWasteCollectDataListThisMonth() {
  return axios.get(GET_SUMMARY_WASTE_COLLECT_DATA_LIST_THIS_MONTH_URL);
}

export function getSummaryWasteCollectDataListAll() {
  return axios.get(GET_SUMMARY_WASTE_COLLECT_DATA_LIST_ALL_URL);
}

